module.exports = __webpack_public_path__ + "img/tasks.3e9c0ca1.svg";